"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _Col = _interopRequireDefault(require("../Col"));
var _Row = _interopRequireDefault(require("../Row"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * This is a [React](https://reactjs.org/) component for the Vanilla [Strip](https://docs.vanillaframework.io/patterns/strip/).
 *
 * The strip pattern provides a full width strip container in which to wrap a row.
 */
const Strip = _ref => {
  let {
    background,
    bordered = false,
    children,
    className,
    colSize = 12,
    dark = false,
    deep = false,
    includeCol = true,
    element: Component = "div",
    light = false,
    rowClassName,
    shallow = false,
    type,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(Component, _extends({
    className: (0, _classnames.default)(className, {
      ["p-strip--".concat(type)]: !!type,
      "p-strip": !type,
      "is-bordered": bordered,
      "is-dark": dark,
      "is-deep": deep,
      "is-light": light,
      "is-shallow": shallow
    }),
    style: background && {
      backgroundImage: "url('".concat(background, "')")
    }
  }, props), /*#__PURE__*/_react.default.createElement(_Row.default, {
    className: rowClassName
  }, includeCol ? /*#__PURE__*/_react.default.createElement(_Col.default, {
    size: colSize
  }, children) : children));
};
var _default = exports.default = Strip;